import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule, xhrStatusFactory } from 'redux/reusable/xhrStatus';
import type { Hour } from 'types/hour';
import type { HoursDetailsFilter } from 'types/hours';
import type { Project } from 'types/project';
import { actionCreatorFactory } from 'typescript-fsa';
import type { HoursDetailsBatchSelection } from './hours.types';
import { HOUR_DETAILS_INITIAL_BATCH_SELECTION, HOUR_DETAILS_INITIAL_FILTER } from './hours.types';

const actionCreator = actionCreatorFactory('timely/user-page');

export const reset = actionCreator('RESET');

export const fetchedUserHours = actionCreator<{ append: boolean; hours: Array<Hour<Project>> }>(
  'FETCHED_USER_HOURS'
);

export const setFilter = actionCreator<Partial<HoursDetailsFilter>>('SET_FILTER');
export const setDefaultFilters = actionCreator<Partial<HoursDetailsFilter>>('SET_DEFAULT_FILTERS');
export const setBatchSelection =
  actionCreator<Partial<HoursDetailsBatchSelection>>('SET_BATCH_SELECTION');
export const resetBatchSelection = actionCreator('RESET_BATCH_SELECTION');

export interface State {
  batchSelection: HoursDetailsBatchSelection;
  filter: HoursDetailsFilter;
  hours: {
    [id: number]: Hour<Project>;
  };
  result: Array<number>;
  xhrStatus: XhrStatus;
}

export const initialState: State = {
  hours: {},
  result: [],
  batchSelection: HOUR_DETAILS_INITIAL_BATCH_SELECTION,
  filter: HOUR_DETAILS_INITIAL_FILTER,
  xhrStatus: xhrStatusFactory(),
};

export const xhrStatusModule = createXhrStatusModule('user-page');
